import { Field, Form, Formik, FormikHelpers } from "formik";
import { Col, Row } from "reactstrap";
import styles from "src/components/Common/UI/MultiStepWizard/MultiStepWizard.module.css";
import * as Yup from "yup";

const EstablishmentInterfaceForm: React.FC<StepProps> = ({
  initialValues,
  onSubmit,
}) => {
  const WizardSchema = Yup.object().shape({
    interfaceID: Yup.string().required("Το πεδίο είναι υποχρεωτικό"),
  });

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={WizardSchema}
        onSubmit={onSubmit}
        enableReinitialize={true}
      >
        {({ errors, touched }) => (
          <Form>
            <Row>
              <Col xs={3}>
                <div className="flex-grow-1">
                  <label className="form-label">{"Interface"}</label>
                </div>
                <div className="mb-3">
                  <Field
                    as="select"
                    name="interfaceID"
                    className="form-control"
                  >
                    <option>Επιλέξτε Interface</option>
                    <option value={9}>Interface 1</option>
                  </Field>
                  <div className="text-danger">
                    {errors.interfaceID && touched.interfaceID && (
                      <div>{errors.interfaceID as string}</div>
                    )}
                  </div>
                </div>
              </Col>
            </Row>
            <button type="submit" className={styles.buttonnext}>
              Αποθήκευση
            </button>
          </Form>
        )}
      </Formik>
    </>
  );
};

interface StepProps {
  type: "create" | "edit";
  initialValues: IEstablishmentInterfaceIDForm;
  onSubmit: (
    values: IEstablishmentInterfaceIDForm,
    formikHelpers: FormikHelpers<IEstablishmentInterfaceIDForm>
  ) => void;
}

export default EstablishmentInterfaceForm;
